import BaseStore from '@src/utils/store/base-store';

class ComponentStore extends BaseStore {
  use(props) {
    super.use(props);
  }
}

export default ComponentStore;
